import {
  PROFIT_MORE_SUGGESTED_PROMPTS,
  PROFIT_PRIMARY_SUGGESTED_PROMPTS,
} from '../investigator/QueryBar';

/** Suggested-prompt chips, shared by the full ZOE page and the pop-up. */
export const ZOE_PRIMARY_PROMPTS = [
  'What needs my attention today?',
  ...PROFIT_PRIMARY_SUGGESTED_PROMPTS.slice(0, 3),
];

export const ZOE_MORE_PROMPTS = [
  'Which deliveries are at risk today?',
  ...PROFIT_MORE_SUGGESTED_PROMPTS,
];
